import { Module } from 'vuex'
import { IAuthState, IRootState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'

const auth: Module<IAuthState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default auth
